import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l16 0","key":"svg-0"}],["path",{"d":"M4 15l4 -6l4 2l4 -5l4 4l0 5l-16 0","key":"svg-1"}]]

/**
 * IconChartArea
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hhcnQtYXJlYSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCAxOWwxNiAwIiAvPgogIDxwYXRoIGQ9Ik00IDE1bDQgLTZsNCAybDQgLTVsNCA0bDAgNWwtMTYgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chart-area
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChartArea = createReactComponent('outline', 'chart-area', 'ChartArea', __iconNode);

export default IconChartArea;